import {renderStructuredElements} from "@/utils/render-helpers.jsx";
import Newsletter from "@/components/FooterNewsletter";

document.addEventListener("DOMContentLoaded", () => {
  renderStructuredElements("footer-newsletter", Newsletter);
});
